<template>
  <div :class="$style.sidebar">
    <div :class="[$style.sidebar__nav, $style['sidebar__nav--with-margin']]">
      <div
        v-for="item in topNavItems"
        :key="item.id"
        :class="[
          $style.sidebar__item,
          { [$style['sidebar__item--active']]: activeSection === item.id }
        ]"
        @click="handleClick(item.id)"
      >
        <svg-sprite
          :name="item.icon"
          :type="item.iconType || 'regular'"
          :size="24"
        />
        <span :class="$style.sidebar__item_text">
          {{ item.label }}
        </span>
      </div>
    </div>
    <div :class="$style.sidebar__nav">
    <div :class="$style.sidebar__separator" />
      <div
        v-for="item in bottomNavItems.filter(i => (typeof i.hidden === 'function' ? !i.hidden() : !i.hidden))"
        :key="item.id"
        :class="$style['sidebar__item--link']"
        @click="handleLinkClick(item)"
      >
        <svg-sprite
          :name="item.icon"
          :type="item.iconType || 'regular'"
          :size="24"
        />
        <span :class="$style.sidebar__item_text">
          {{ item.label }}
        </span>
        <svg-sprite
          v-if="item.rightIcon"
          :class="$style.sidebar__item_right_icon"
          :name="item.rightIcon"
          :type="'regular'"
          :size="item.rightIconSize || 20"
        />
      </div>
    </div>
    <div :class="$style.sidebar__nav">
      <div
        v-if="shouldShowTranslationError"
        :class="$style.sidebar__separator"
      />
      <div
        v-for="item in utilityItems"
        :key="item.id"
        :class="[
          $style.sidebar__item,
          { [$style['sidebar__item--active']]: activeSection === item.id }
        ]"
        @click="handleClick(item.id)"
      >
        <svg-sprite
          :name="item.icon"
          :type="item.iconType || 'regular'"
          :size="24"
        />
        <span :class="$style.sidebar__item_text">
          {{ item.label }}
        </span>
      </div>
      <div
        v-if="shouldShowTranslationError"
        :class="[
          $style.sidebar__item,
          { [$style['sidebar__item--active']]: activeSection === SIDEBAR_SECTIONS.TRANSLATION_ERROR }
        ]"
        @click="handleClick(SIDEBAR_SECTIONS.TRANSLATION_ERROR)"
      >
        <svg-sprite
          name="language"
          type="regular"
          :size="24"
        />
        <span :class="$style.sidebar__item_text">
          {{ translationErrorLabel }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import SvgSprite from '$$vueCmp/VueIcon/svgSprite.vue';
import rights from '../../../../components/rights/index';
import plansModel from '../../../../models/plans';
import { SIDEBAR_SECTIONS, SIDEBAR_TOP_NAV_CONFIG, SIDEBAR_UTILITY_NAV_CONFIG } from '../../learningCenter.config';


const currentLocale = window.user.locale;
const supportedLocales = ['ru', 'es'];
const LOCALE = supportedLocales.includes(currentLocale) ? currentLocale : 'en-us';

const HELP_CENTER_URL = `https://help.ganttpro.com/hc/${LOCALE}`;
const SUPPORT_URL = `https://support.ganttpro.com`;

export default {
  name: 'LearningCenterSidebar',
  components: {
    SvgSprite,
  },
  props: {
    activeSection: {
      type: String,
      required: true,
    },
    hasUnreadNews: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['section-change'],
  data() {
    return {
      SIDEBAR_SECTIONS,
      locales: __,
      topNavItems: SIDEBAR_TOP_NAV_CONFIG.map(item => ({
        ...item,
        label: __(item.label),
      })),
      bottomNavItems: [
        {
          id: SIDEBAR_SECTIONS.HELP,
          icon: 'helpCenter',
          iconType: 'regular',
          label: __('lc_sidebar_help_center'),
          showMarker: false,
          rightIcon: 'link-2',
          rightIconType: 'regular',
          rightIconSize: 20,
          isLink: true,
          clickHandler: () => {
            window.open(HELP_CENTER_URL, '_blank');
          },
        },
        {
          id: SIDEBAR_SECTIONS.SUPPORT,
          icon: 'support',
          iconType: 'regular',
          label: __('lc_sidebar_support'),
          showMarker: false,
          isLink: true,
          clickHandler: () => {
            const ID_KEY_STORAGE_CHAT_MISSING = 'liveChatMissing';
            const isChatMissing = webix.storage.local.get(ID_KEY_STORAGE_CHAT_MISSING);
            if (isChatMissing) {
              webix.storage.local.put(ID_KEY_STORAGE_CHAT_MISSING, false);
            }
            this.$store.dispatch('footer/chatClickHandler');
          },
        },
        {
          id: SIDEBAR_SECTIONS.DEMO,
          icon: 'demo',
          iconType: 'regular',
          label: __('lc_sidebar_demo'),
          isLink: true,
          hidden: () => {
            const isOwner = window.user?.team?.is_owner || rights.account.isOwner();
            const isTrial = plansModel.isTrial();
            const isPaid = plansModel.isPaidPlan();
            return !isOwner || !isTrial || isPaid;
          },
          clickHandler: () => {
            this.$store.dispatch('footer/demoClickHandler', { campaign: 'appLearningCenterTab' });
          },
        },
      ],
      utilityItems: SIDEBAR_UTILITY_NAV_CONFIG.map(item => ({
        ...item,
        label: __(item.label),
      })),
    };
  },
  computed: {
    shouldShowTranslationError() {
      const currentLocale = window.user?.locale || 'en';
      const supportedLocales = ['it', 'hi', 'pl', 'zh', 'ja', 'tr', 'nl', 'sv', 'vi', 'uk', 'no', 'fi'];
      return supportedLocales.includes(currentLocale);
    },
    translationErrorLabel() {
      return __('lc_sidebar_translation_error');
    },
  },
  methods: {
    handleClick(sectionId) {
      this.$emit('section-change', sectionId);
    },
    handleLinkClick(item) {
      if (item.clickHandler) {
        item.clickHandler();
      }
    },
  },
};
</script>

<style module src="../less/learningCenterSidebar.less" lang="less">
</style>

